const options = [
  {
    label: "最近30天",
    value: 30
  }
];

const daily = [
  {
    label: "Trade Date",
    field: "a"
  },
  // {
  //   label: "Unit",
  //   field: "b"
  // },
  // {
  //   label: "Market",
  //   field: "c"
  // },
  {
    label: "Open",
    field: "d"
  },
  {
    label: "Trade Volume",
    field: "e"
  },
  {
    label: "High",
    field: "f"
  },
  {
    label: "Low",
    field: "g"
  },
  {
    label: "Close",
    field: "h"
  },
  {
    label: "Percentage Change (%)",
    field: "i"
  }
]

const monthlyPricing = [
  {
    label: "Unit",
    field: "a"
  },
  {
    label: "Open",
    field: "a"
  },
  {
    label: "High",
    field: "a"
  },
  {
    label: "Low",
    field: "a"
  },
  {
    label: "Close",
    field: "a"
  },
  {
    label: "Volume(shares)",
    field: "a"
  },
  {
    label: "No of days traded",
    field: "a"
  },
  {
    label: "Shares outstanding",
    field: "a"
  },
  {
    label: "Market cap",
    field: "a"
  }
];


const performance = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Performance Type Code",
    field: "a"
  },
  {
    label: "Performance Type",
    field: "a"
  },
  {
    label: "业绩预告内容",
    field: "a"
  },
  {
    label: "业绩变化原因",
    field: "a"
  },
  {
    label: "Last",
    field: "a"
  },
  {
    label: "本期净利润下限",
    field: "a"
  },
  {
    label: "本期净利润上限",
    field: "a"
  },
  {
    label: "本期净利润增减幅下限",
    field: "a"
  },
  {
    label: "本期净利润增减幅下限",
  }
]

const dividend = [
  {
    label: "Implementation Announced Date",
    field: "implementation_announced_date"
  },
  {
    label: "Ex-Date",
    field: "ex_date"
  },
  {
    label: "Record Date",
    field: "record_date"
  },
  {
    label: "Bonus Issue per 10 Shares from Profit",
    field: "bonus_issue_per_10_shares_from_profit"
  },
  {
    label: "Bonus Issue per 10 Shares from Capital Reserve",
    field: "bonus_issue_per_10_shares_from_capital_reserve"
  },
  {
    label: "Cash Dividends per 10 Shares",
    field: "cash_dividends_per_10_shares"
  },
  {
    label: "Payment Date (Bonus Shares from Profit)",
    field: "payment_date_bonus_shares_from_profit"
  },
  {
    label: "Payment Date (Bonus Shares from Capital Reserve)",
    field: "payment_date_bonus_shares_from_capital_reserve"
  }
]

const annualStock = [
  {
    label: "year",
    field: "a"
  },
  {
    label: "Price/earnings ratio",
    field: "",
    children: [
      {
        label: "Year end",
        field: "a"
      },
      {
        label: "Open",
        field: "a"
      },
      {
        label: "High",
        field: "a"
      },
      {
        label: "Low",
        field: "a"
      },
      {
        label: "Average",
        field: "a"
      }
    ]
  },
  {
    label: "Earnings yield (%)",
    field: "",
    children: [
      {
        label: "Year end",
        field: "a"
      },
      {
        label: "Open",
        field: "a"
      },
      {
        label: "High",
        field: "a"
      },
      {
        label: "Low",
        field: "a"
      },
      {
        label: "Average",
        field: "a"
      }
    ]
  },
  {
    label: "Price / cash flow ratio",
    field: "a"
  },
  {
    label: "Dividend yield (%)",
    field: "",
    children: [
      {
        label: "Year end",
        field: "a"
      },
      {
        label: "Open",
        field: "a"
      },
      {
        label: "High",
        field: "a"
      },
      {
        label: "Low",
        field: "a"
      },
      {
        label: "Average",
        field: "a"
      }
    ]
  },
  {
    label: "Dividend payout (%)",
    field: "a"
  },
  {
    label: "Price/book value ratio",
    field: "",
    children: [
      {
        label: "Year end",
        field: "a"
      },
      {
        label: "Open",
        field: "a"
      },
      {
        label: "High",
        field: "a"
      },
      {
        label: "Low",
        field: "a"
      },
      {
        label: "Average",
        field: "a"
      }
    ]
  },
  {
    label: "Market Capitalisation / shareholders funds",
    field: "a"
  },
  {
    label: "Market capitalisation / Total assets (Tobin’s Q)",
    field: "a"
  }
]

const caSummary = [
  {
    label: "Announcement Date",
    field: "announcement_date",
    width: "150px"
  },
  {
    label: "CA Type",
    field: "ca_type",
    width: "200px"
  },
  // {
  //   label: "Summary",
  //   field: "summary"
  // }
]

export default {
  options,
  daily,
  monthlyPricing,
  dividend,
  performance,
  annualStock,
  caSummary
}